import { useEffect, useState } from 'react'

/** A stable "now" for render purity; ticks every `everyMs` when given. */
export const useNow = (everyMs?: number): number => {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!everyMs) return
    const i = setInterval(() => setNow(Date.now()), everyMs)
    return () => clearInterval(i)
  }, [everyMs])
  return now
}
